import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { autosuggestFinanceClient } from '#pplx_generated/typespec/rest/autosuggest/finance/client.js';
export const getFinanceSuggestions = async ({ query, reason, country, }) => {
    try {
        const { data, error, response } = await autosuggestFinanceClient.GET('/rest/autosuggest/finance/list-autosuggest', reason, {
            params: {
                query: {
                    query,
                    country,
                },
            },
            timeoutMs: 0,
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
            });
        }
        return data?.results ?? EMPTY_ARRAY;
    }
    catch (err) {
        logger.error(err);
        return [];
    }
};
//# sourceMappingURL=getFinanceSuggestions.js.map